import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGlobalMessage, IGlobalMessagesState } from "./globalMessages.types";

const initialState: IGlobalMessagesState = {
  currentMessage: null,
  loaderCount: 0,
};

const globalMessagesSlice = createSlice({
  name: "globalMessages",
  initialState,
  reducers: {
    showGlobalMessage(state, action: PayloadAction<IGlobalMessage>) {
      state.currentMessage = action.payload;
    },
    hideGlobalMessage(state) {
      state.currentMessage = null;
    },
    incrementLoader(state) {
      state.loaderCount += 1;
    },
    decrementLoader(state) {
      state.loaderCount = Math.max(0, state.loaderCount - 1);
    },
  },
});

export const {
  showGlobalMessage,
  hideGlobalMessage,
  incrementLoader,
  decrementLoader,
} = globalMessagesSlice.actions;

export default globalMessagesSlice.reducer;
